import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import './Fonts.css';
import { SiteContextProvider } from './contexts/Site';
import TorrentContextProvider from './contexts/Torrent/TorrentContextProvider';
import Site from './components/site';
import { KeystoneSite, ValentinesSite } from './components/special';


function App() {
  return (
    <div className="App">
      <TorrentContextProvider>
        <SiteContextProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Site />}></Route>
              <Route path="/keystone" element={<KeystoneSite />}></Route>
              <Route path="/valentines" element={<ValentinesSite />}></Route>
              <Route path="/*" element={<Site />}></Route>
            </Routes>
          </Router>
        </SiteContextProvider>
      </TorrentContextProvider>
    </div>
  );
}

export default App;
